import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IRcnLatestStats} from "../types/IRcnStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getRcnLatestGrainQueries, pickRcnLatestPoint, RCN_GRAIN_FAILED, toRcnGrainAnswer} from "../utils/resolve_rcn_latest_point";
import {useRcnPeriodStats} from "./use_rcn_period_stats";

export type {IRcnLatestStats, IRcnStats} from "../types/IRcnStats";

/**
 * The address's newest published point: the newest point of month, quarter and year, the latest period winning and a
 * tie going to the finer grain (see resolve_rcn_latest_point). The three grains are queried in parallel with the
 * very queries the server prefetch makes, so the page hydrates from its cache without a request; in the browser the
 * year query is usually a cache hit too (the availability probe). Loading until every grain has answered.
 *
 * A failed grain is left out of the pick - the point is then the newest of the grains that answered (isError says
 * so) - and RTK Query retries the failed query when a component subscribes again (on hydration too, for a grain
 * that failed on the server). While that retry is pending the grain still counts as failed, so the server-rendered
 * point stays instead of flashing to a loader; a successful retry can then move the point to a newer period. "total" is read for the period and
 * grain the per m² point resolved to, so both describe the same sales.
 */
export const useRcnLatestStats = (target: RcnStatsTarget | null | undefined, rooms: RoomsFilter, unit: RcnPriceStatsQuery["unit"]): IRcnLatestStats => {
    const [monthQuery, quarterQuery, yearQuery] = getRcnLatestGrainQueries(target ?? 0, rooms);

    const month = useGetRcnDataQuery(monthQuery, {skip: !target});
    const quarter = useGetRcnDataQuery(quarterQuery, {skip: !target});
    const year = useGetRcnDataQuery(yearQuery, {skip: !target});

    const grains = [month, quarter, year];
    const answers = grains.map(({currentData, isError, error}) => toRcnGrainAnswer({data: currentData, isError, error}));
    const resolved = target ? pickRcnLatestPoint(answers) : null;
    const perM2 = resolved === "pending" ? null : resolved;
    // A failed grain being retried is not loading: the point of the grains that answered stays on screen meanwhile.
    const isGrainsLoading = resolved === "pending" || grains.some((grain, index) => grain.isFetching && answers[index] !== RCN_GRAIN_FAILED);
    const isGrainsError = answers.includes(RCN_GRAIN_FAILED);

    const total = useRcnPeriodStats(unit === "total" && perM2 ? target : null, rooms, "total", perM2?.point.period_start ?? null, perM2?.grain ?? null);

    if (unit === "total") {
        return {
            point: total.point,
            grain: perM2 && total.point ? perM2.grain : null,
            isLoading: isGrainsLoading || total.isLoading,
            isError: isGrainsError || total.isError
        };
    }

    return {
        point: perM2?.point ?? null,
        grain: perM2?.grain ?? null,
        isLoading: isGrainsLoading,
        isError: isGrainsError
    };
};
import {useGetRcnDataQuery} from "../api/get_rcn_data_api";
import {RoomsFilter} from "../constants/rcn_rooms_filter";
import {IRcnLatestStats} from "../types/IRcnStats";
import {RcnPriceStatsQuery, RcnStatsTarget} from "../types/RcnPriceStatsQuery";
import {getRcnLatestGrainQueries, pickRcnLatestPoint, RCN_GRAIN_FAILED, toRcnGrainAnswer} from "../utils/resolve_rcn_latest_point";
import {useRcnPeriodStats} from "./use_rcn_period_stats";

export type {IRcnLatestStats, IRcnStats} from "../types/IRcnStats";

/**
 * The address's newest published point: the newest point of month, quarter and year, the latest period winning and a
 * tie going to the finer grain (see resolve_rcn_latest_point). The three grains are queried in parallel with the
 * very queries the server prefetch makes, so the page hydrates from its cache without a request; in the browser the
 * year query is usually a cache hit too (the availability probe). Loading until every grain has answered.
 *
 * A failed grain is left out of the pick - the point is then the newest of the grains that answered (isError says
 * so) - and RTK Query retries the failed query when a component subscribes again (on hydration too, for a grain
 * that failed on the server). While that retry is pending the grain still counts as failed, so the server-rendered
 * point stays instead of flashing to a loader; a successful retry can then move the point to a newer period. "total" is read for the period and
 * grain the per m² point resolved to, so both describe the same sales.
 */
export const useRcnLatestStats = (target: RcnStatsTarget | null | undefined, rooms: RoomsFilter, unit: RcnPriceStatsQuery["unit"]): IRcnLatestStats => {
    const [monthQuery, quarterQuery, yearQuery] = getRcnLatestGrainQueries(target ?? 0, rooms);

    const month = useGetRcnDataQuery(monthQuery, {skip: !target});
    const quarter = useGetRcnDataQuery(quarterQuery, {skip: !target});
    const year = useGetRcnDataQuery(yearQuery, {skip: !target});

    const grains = [month, quarter, year];
    const answers = grains.map(({currentData, isError, error}) => toRcnGrainAnswer({data: currentData, isError, error}));
    const resolved = target ? pickRcnLatestPoint(answers) : null;
    const perM2 = resolved === "pending" ? null : resolved;
    // A failed grain being retried is not loading: the point of the grains that answered stays on screen meanwhile.
    const isGrainsLoading = resolved === "pending" || grains.some((grain, index) => grain.isFetching && answers[index] !== RCN_GRAIN_FAILED);
    const isGrainsError = answers.includes(RCN_GRAIN_FAILED);

    const total = useRcnPeriodStats(unit === "total" && perM2 ? target : null, rooms, "total", perM2?.point.period_start ?? null, perM2?.grain ?? null);

    if (unit === "total") {
        return {
            point: total.point,
            grain: perM2 && total.point ? perM2.grain : null,
            isLoading: isGrainsLoading || total.isLoading,
            isError: isGrainsError || total.isError
        };
    }

    return {
        point: perM2?.point ?? null,
        grain: perM2?.grain ?? null,
        isLoading: isGrainsLoading,
        isError: isGrainsError
    };
};
